const hazardousElem = document.querySelector('[name="attributes[hazardous]"]');
const hazardousProductsElem = document.querySelector(
  '[name="attributes[hazardousProducts]"]',
);

const oversizeElem = document.querySelector('[name="attributes[oversize]"]');
const oversizeProductsElem = document.querySelector(
  '[name="attributes[oversizeProducts]"]',
);

const tintedElem = document.querySelector('[name="attributes[tinted]"]');
const tintedProductsElem = document.querySelector(
  '[name="attributes[tintedProducts]"]',
);

function getDropShipElems() {
  return {
    hasDropShip: document.querySelector('[name="attributes[hasDropShip]"]'),
    onlyDropShip: document.querySelector('[name="attributes[onlyDropShip]"]'),
    dropShipProducts: document.querySelector(
      '[name="attributes[dropShipProducts]"]',
    ),
  };
}

const customCheckoutError = document.getElementById("custom-checkout-error");
const customCheckoutErrorMobile = document.getElementById(
  "custom-checkout-error-mobile",
);

const blockedMessage = document.getElementById(
  "custom-checkout-blocked-message",
);

const blockedMessageMobile = document.getElementById(
  "custom-checkout-blocked-message-mobile",
);

const hazardousMessage = document.getElementById(
  "custom-checkout-hazardous-message",
);

const hazardousMessageMobile = document.getElementById(
  "custom-checkout-hazardous-message-mobile",
);

const oversizeMessage = document.getElementById(
  "custom-checkout-oversize-message",
);

const oversizeMessageMobile = document.getElementById(
  "custom-checkout-oversize-message-mobile",
);

const tintedMessage = document.getElementById("custom-checkout-tinted-message");

const tintedMessageMobile = document.getElementById(
  "custom-checkout-tinted-message-mobile",
);

const estimateButton = document.getElementById("cart-shipping-estimate-submit");
const estimateButtonMobile = document.getElementById(
  "cart-shipping-estimate-submit-mobile",
);

const cartShippingEstimateForm = document.getElementById(
  "cart-shipping-estimate-form",
);
const cartShippingEstimateFormMobile = document.getElementById(
  "cart-shipping-estimate-form-mobile",
);

const postcodeElem = document.getElementById("cart-shipping-estimate-postcode");
const postcodeElemMobile = document.getElementById(
  "cart-shipping-estimate-postcode-mobile",
);
const cartForm = document.getElementById("cart");
const checkoutButton = Array.from(document.querySelectorAll("#checkout"));
const cartErrors = document.getElementById("cart-errors");

const resultElem = document.getElementById("cart-shipping-estimate-result");
const resultElemMobile = document.getElementById(
  "cart-shipping-estimate-result-mobile",
);

const ellipsis = `<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"margin: auto; background: none; display: block; shape-rendering: auto;\" width=\"50px\" height=\"50px\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\">\r\n<circle cx=\"84\" cy=\"50\" r=\"10\" fill=\"#ffffff\">\r\n    <animate attributeName=\"r\" repeatCount=\"indefinite\" dur=\"0.5319148936170213s\" calcMode=\"spline\" keyTimes=\"0;1\" values=\"10;0\" keySplines=\"0 0.5 0.5 1\" begin=\"0s\"></animate>\r\n    <animate attributeName=\"fill\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"discrete\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"#ffffff;#ffffff;#ffffff;#ffffff;#ffffff\" begin=\"0s\"></animate>\r\n</circle><circle cx=\"16\" cy=\"50\" r=\"10\" fill=\"#ffffff\">\r\n  <animate attributeName=\"r\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"0;0;10;10;10\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"0s\"></animate>\r\n  <animate attributeName=\"cx\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"16;16;16;50;84\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"0s\"></animate>\r\n</circle><circle cx=\"50\" cy=\"50\" r=\"10\" fill=\"#ffffff\">\r\n  <animate attributeName=\"r\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"0;0;10;10;10\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-0.5319148936170213s\"></animate>\r\n  <animate attributeName=\"cx\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"16;16;16;50;84\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-0.5319148936170213s\"></animate>\r\n</circle><circle cx=\"84\" cy=\"50\" r=\"10\" fill=\"#ffffff\">\r\n  <animate attributeName=\"r\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"0;0;10;10;10\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-1.0638297872340425s\"></animate>\r\n  <animate attributeName=\"cx\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"16;16;16;50;84\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-1.0638297872340425s\"></animate>\r\n</circle><circle cx=\"16\" cy=\"50\" r=\"10\" fill=\"#ffffff\">\r\n  <animate attributeName=\"r\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"0;0;10;10;10\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-1.5957446808510638s\"></animate>\r\n  <animate attributeName=\"cx\" repeatCount=\"indefinite\" dur=\"2.127659574468085s\" calcMode=\"spline\" keyTimes=\"0;0.25;0.5;0.75;1\" values=\"16;16;16;50;84\" keySplines=\"0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1\" begin=\"-1.5957446808510638s\"></animate>\r\n</circle>\r\n<!-- [ldio] generated by https://loading.io/ --></svg>`;

const fetchEndpointRoot =
  window.location.hostname.search(/new-store/gm) === -1
    ? "next-day-paint"
    : "next-day-paint-dev";

const selectedShippingServiceCodeElem = document.querySelector(
  '[name="attributes[selectedShippingServiceCode]"]',
);

const selectedShippingServiceNameElem = document.querySelector(
  '[name="attributes[selectedShippingServiceName]"]',
);

const showSuperScriptPrices = cart.dataset.showSuperScriptPrices === "true";

const backupRate = {
  service_code: "backup-preselected",
  service_name: "Standard Delivery",
  description: "Standard delivery",
  total_price: 399,
};

let hazardous = 0;
let oversize = 0;
let tinted = 0;
let hazardousProducts = [];
let oversizeProducts = [];
let tintedProducts = [];
let preselectedFound = false;
let preClick = false;

function formatMoney(number) {
  let parsedNumber =
    typeof number === "string"
      ? parseFloat(number.replaceAll(",", ""))
      : number;

  return new Intl.NumberFormat("en-gb", {
    style: "currency",
    currency: "GBP",
  }).format(parsedNumber / 100);
}

function superScriptMoney(moneyString) {
  if (themeMoneyFormat.includes("comma")) {
    return `${moneyString.replace(",", "<sup>")}</sup>`;
  } else {
    return `${moneyString.replace(".", "<sup>")}</sup>`;
  }
}

function updateCart() {
  const cartErrors = document.getElementById("cart-errors");

  fetch("/cart/update.js", {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify({
      attributes: {
        hazardous: hazardous,
        oversize: oversize,
        tinted: tinted,

        selectedShippingServiceCode: document.querySelector(
          '[name="attributes[selectedShippingServiceCode]"]',
        ).value,

        selectedShippingServiceName: document.querySelector(
          '[name="attributes[selectedShippingServiceName]"]',
        ).value,

        hazardousProducts: hazardousProductsElem.value,
        oversizeProducts: oversizeProductsElem.value,
        tintedProducts: tintedProductsElem.value,
        ...(() => {
          const d = getDropShipElems();
          return {
            hasDropShip: d.hasDropShip?.value === "true" ? 1 : 0,
            onlyDropShip: d.onlyDropShip?.value === "true" ? 1 : 0,
            dropShipProducts: d.dropShipProducts?.value || "",
          };
        })(),
      },
    }),
  })
    .then((response) => response.json())
    .then((responseData) => {
      console.log(responseData);

      if (responseData.failed) {
        cartErrors.innerText = responseData.error_message;
        cartErrors.style.display = "block";
        resetCheckoutButton(checkoutButton);
      } else {
        cartErrors.innerText = "";
        cartErrors.style.display = "none";

        let discountCodeElem = document.querySelector(
          '[name="attributes[discountCode]"]',
        );

        let discountCodeInput = document.getElementById(
          "cart-discount-code-input",
        );

        if (discountCodeElem?.value && discountCodeElem.value != " ") {
          window.location.href = `/checkout/?discount=${discountCodeElem.value}`;
        } else if (discountCodeInput?.value && discountCodeInput.value != " ") {
          window.location.href = `/checkout/?discount=${discountCodeInput.value}`;
        } else {
          window.location.href = "/checkout?step=contact_information";
        }
        //document.querySelector('#cart').submit();
      }
    })
    .catch((error) => {
      console.error(error);

      cartErrors.innerText =
        "Oops! Looks like something has gone wrong. Please refresh the page or try again later";

      cartErrors.style.display = "block";

      resetCheckoutButton(checkoutButton);
    });
}

function assignHazardous(items) {
  hazardous = 0;
  oversize = 0;
  tinted = 0;
  hazardousProducts = [];
  oversizeProducts = [];
  tintedProducts = [];

  items.forEach((item) => {
    if (
      item.properties._hazardous === true ||
      item.properties._hazardous === "true"
    ) {
      hazardous = 1;
      hazardousElem.value = true;
      hazardousProducts.push(item.title);
    } else {
      hazardousElem.value = false;
    }

    if (
      item.properties._oversize === true ||
      item.properties._oversize === "true"
    ) {
      oversize = 1;
      oversizeElem.value = true;
      oversizeProducts.push(item.title);
    } else {
      oversizeElem.value = false;
    }

    if (
      item.properties._tinted === true ||
      item.properties._tinted === "true"
    ) {
      tinted = 1;
      tintedElem.value = true;
      tintedProducts.push(item.title);
    } else {
      tintedElem.value = false;
    }
  });

  if (hazardousProducts.length > 0) {
    hazardousProductsElem.value = hazardousProducts.join(";;");
  } else {
    hazardousProductsElem.value = "";
  }

  if (oversizeProducts.length > 0) {
    oversizeProductsElem.value = oversizeProducts.join(";;");
  } else {
    oversizeProductsElem.value = "";
  }

  if (tintedProducts.length > 0) {
    tintedProductsElem.value = tintedProducts.join(";;");
  } else {
    tintedProductsElem.value = "";
  }
}

function checkSelectedShipping() {
  document.querySelectorAll(".shipping-rate-card").forEach((card) => {
    if (
      card
        .querySelector(".shipping-rate-radio-inner")
        .classList.contains("shipping-rate-radio-selected")
    ) {
      selectedShippingServiceCodeElem.value = card.getAttribute("service-code");
      selectedShippingServiceNameElem.value = card.getAttribute("service-name");
    }
  });
}

function resetButton() {
  estimateButton.removeAttribute("disabled");
  estimateButton.innerHTML = "Check";

  estimateButtonMobile.removeAttribute("disabled");
  estimateButtonMobile.innerHTML = "Check";
}

function resetDiscountButton(button) {
  button.removeAttribute("disabled");
  button.innerHTML = "Apply";
}

function disableCheckoutButton(buttons) {
  buttons.forEach((button) => {
    button.setAttribute("disabled", "disabled");
    button.innerHTML = "Check out";
  });
}

function resetCheckoutButton(buttons) {
  buttons.forEach((button) => {
    button.removeAttribute("disabled");
    button.innerHTML = "Check out";
  });
}

function handleRateClick(serviceCode, serviceName, totalPrice) {
  document.querySelectorAll(".shipping-rate-card").forEach((card) => {
    card
      .querySelector(".shipping-rate-radio-inner")
      .classList.remove("shipping-rate-radio-selected");
    if (
      card.getAttribute("service-code") == serviceCode &&
      card.getAttribute("service-name") == serviceName
    ) {
      card
        .querySelector(".shipping-rate-radio-inner")
        .classList.add("shipping-rate-radio-selected");
    }
  });
  selectedShippingServiceCodeElem.value = serviceCode;
  selectedShippingServiceNameElem.value = serviceName;
  updateTotals(totalPrice);
  document.querySelectorAll(".shipping-rate-card").forEach((card) => {
    card
      .querySelector(".shipping-rate-radio-inner")
      .classList.remove("shipping-rate-radio-selected");
    if (
      card.getAttribute("service-code") == serviceCode &&
      card.getAttribute("service-name") == serviceName
    ) {
      card
        .querySelector(".shipping-rate-radio-inner")
        .classList.add("shipping-rate-radio-selected");
    }
  });
  selectedShippingServiceCodeElem.value = serviceCode;
  selectedShippingServiceNameElem.value = serviceName;
  updateTotals(totalPrice);
}

function updateTotals(shippingPrice) {
  const subtotalElem = document.querySelector("#cart-footer-subtotal");
  const shippingElem = document.querySelector("#cart-footer-shipping");
  const totalElem = document.querySelector("#cart-footer-total");
  const mobileCartHeaderTotal = document.querySelector("#cart-header-subtotal");
  const mobilePriceIncEx = document.querySelector(".price-includes");
  const isB2B = subtotalElem.getAttribute("data-is-b2b");

  if (shippingPrice === 0) {
    shippingElem.innerHTML = `FREE`;
    totalElem.innerHTML = subtotalElem.innerHTML;
  } else {
    let subtotalText = subtotalElem.textContent;
    let subtotalAmount = parseInt(subtotalText.replaceAll(/\D/gm, ""));
    let subtotalCurrency = subtotalText.replaceAll(/\d/gm, "");
    const vatRate =
      parseFloat(subtotalElem.getAttribute("data-vat-rate")) || 1.2;
    const b2bIncVat = subtotalAmount * vatRate;
    let totalAmount = subtotalAmount + shippingPrice;

    if (isB2B === "true") {
      totalAmount = b2bIncVat + shippingPrice;
      console.log(totalAmount);
    }

    if (shippingPrice < 100) {
      shippingElem.innerHTML = "£0";
    } else {
      shippingElem.innerHTML = showSuperScriptPrices
        ? superScriptMoney(formatMoney(shippingPrice))
        : formatMoney(shippingPrice);
    }

    if (totalAmount < 100) {
      totalElem.innerHTML = "£0";
    } else {
      totalElem.innerHTML = showSuperScriptPrices
        ? superScriptMoney(formatMoney(totalAmount))
        : formatMoney(totalAmount);
      mobileCartHeaderTotal.innerHTML = showSuperScriptPrices
        ? superScriptMoney(formatMoney(totalAmount))
        : formatMoney(totalAmount);
      mobilePriceIncEx.innerHTML = "(Including delivery)";
    }

    // shippingElem.innerHTML = `${subtotalCurrency}${shippingPrice < 100 ? '0' : parseInt(shippingPrice/100)}<sup>${shippingPrice % 100 < 10 ? '0' : ''}${shippingPrice % 100}</sup>`;
    // totalElem.innerHTML = `${subtotalCurrency}${totalAmount < 100 ? '0' : parseInt(totalAmount/100)}<sup>${totalAmount % 100 < 10 ? '0' : ''}${totalAmount % 100}</sup>`;
  }
}

if (estimateButton != null) {
  cartShippingEstimateForm.addEventListener("submit", handleEstimateSubmit);
  cartShippingEstimateFormMobile.addEventListener(
    "submit",
    handleEstimateSubmit,
  );

  estimateButton.addEventListener("click", handleEstimateSubmit);
  estimateButtonMobile.addEventListener("click", handleEstimateSubmit);

  function handleEstimateSubmit(e) {
    e.preventDefault();

    resetCheckoutButton(checkoutButton);

    estimateButton.setAttribute("disabled", "disabled");
    estimateButton.innerHTML = ellipsis;

    estimateButtonMobile.setAttribute("disabled", "disabled");
    estimateButtonMobile.innerHTML = ellipsis;

    customCheckoutError.style.display = "none";
    customCheckoutErrorMobile.style.display = "none";

    blockedMessage.style.display = "none";
    blockedMessageMobile.style.display = "none";

    hazardousMessage.style.display = "none";
    hazardousMessageMobile.style.display = "none";

    oversizeMessage.style.display = "none";
    oversizeMessageMobile.style.display = "none";

    tintedMessage.style.display = "none";
    tintedMessageMobile.style.display = "none";

    resultElem.innerHTML = ``;
    resultElemMobile.innerHTML = ``;

    preselectedFound = false;
    selectedShippingServiceCodeElem.value = "";
    selectedShippingServiceNameElem.value = "";

    let postcode = postcodeElem.value;

    if (postcodeElemMobile.value != "") {
      postcode = postcodeElemMobile.value;
    }

    if (postcode) {
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          console.log(cart);
          assignHazardous(cart.items);

          fetch(
            "https://etempashopifyapps-server-a.co.uk/endpoints/carrier_service/carrier_service_callback.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              mode: "cors",
              body: JSON.stringify({
                hazardous: hazardous,
                oversize: oversize,
                tinted: tinted,
                ...(() => {
                  const d = getDropShipElems();
                  return {
                    hasDropShip: d.hasDropShip?.value === "true" ? 1 : 0,
                    onlyDropShip: d.onlyDropShip?.value === "true" ? 1 : 0,
                    dropShipProducts: d.dropShipProducts?.value || "",
                  };
                })(),
                rate: {
                  destination: {
                    postal_code: postcode,
                  },
                },
              }),
            },
          )
            .then((response) => response.json())
            .then((responseData) => {
              console.log(responseData);
              console.log(responseData.invalid_postcode);

              if (responseData.failed) {
                customCheckoutError.innerText = responseData.error_message;
                customCheckoutError.style.display = "block";

                customCheckoutErrorMobile.innerText =
                  responseData.error_message;
                customCheckoutErrorMobile.style.display = "block";

                resetButton();
              } else if (responseData.invalid_postcode) {
                customCheckoutError.innerText =
                  "Please enter a full UK postcode";
                customCheckoutError.style.display = "block";

                customCheckoutErrorMobile.innerText =
                  "Please enter a full UK postcode";
                customCheckoutErrorMobile.style.display = "block";

                disableCheckoutButton(checkoutButton);
                resetButton();
              } else if (responseData.blocked) {
                blockedMessage.style.display = "block";
                blockedMessageMobile.style.display = "block";

                disableCheckoutButton(checkoutButton);
                resetButton();
              } else if (responseData.no_hazardous) {
                var hazardousMessageLastChild =
                  hazardousMessage.lastElementChild;

                while (hazardousMessageLastChild) {
                  hazardousMessage.removeChild(hazardousMessageLastChild);
                  hazardousMessageLastChild = hazardousMessage.lastElementChild;
                }

                var hazardousMessageLastChildMobile =
                  hazardousMessageMobile.lastElementChild;

                while (hazardousMessageLastChildMobile) {
                  hazardousMessageMobile.removeChild(
                    hazardousMessageLastChildMobile,
                  );
                  hazardousMessageLastChildMobile =
                    hazardousMessageMobile.lastElementChild;
                }

                if (hazardousProducts.length > 0) {
                  let ul = document.createElement("ul");

                  hazardousProducts.forEach((product) => {
                    let li = document.createElement("li");
                    li.innerText = product.trim();
                    ul.append(li);
                  });

                  hazardousMessage.append(ul);
                  hazardousMessageMobile.append(ul.cloneNode(true));

                  disableCheckoutButton(checkoutButton);
                }

                hazardousMessage.style.display = "block";
                hazardousMessageMobile.style.display = "block";

                resetButton();
              } else if (responseData.no_oversize) {
                var oversizeMessageLastChild = oversizeMessage.lastElementChild;

                while (oversizeMessageLastChild) {
                  oversizeMessage.removeChild(oversizeMessageLastChild);
                  oversizeMessageLastChild = oversizeMessage.lastElementChild;
                }

                var oversizeMessageLastChildMobile =
                  oversizeMessageMobile.lastElementChild;

                while (oversizeMessageLastChildMobile) {
                  oversizeMessageMobile.removeChild(
                    oversizeMessageLastChildMobile,
                  );
                  oversizeMessageLastChildMobile =
                    oversizeMessageMobile.lastElementChild;
                }

                if (oversizeProducts.length > 0) {
                  let ul = document.createElement("ul");

                  oversizeProducts.forEach((product) => {
                    let li = document.createElement("li");
                    li.innerText = product.trim();
                    ul.append(li);
                  });

                  oversizeMessage.append(ul);
                  oversizeMessageMobile.append(ul.cloneNode(true));

                  disableCheckoutButton(checkoutButton);
                }

                oversizeMessage.style.display = "block";
                oversizeMessageMobile.style.display = "block";

                resetButton();
              } else if (responseData.no_tinted) {
                var tintedMessageLastChild = tintedMessage.lastElementChild;

                while (tintedMessageLastChild) {
                  tintedMessage.removeChild(tintedMessageLastChild);
                  tintedMessageLastChild = tintedMessage.lastElementChild;
                }

                var tintedMessageLastChildMobile =
                  tintedMessageMobile.lastElementChild;

                while (tintedMessageLastChildMobile) {
                  tintedMessageMobile.removeChild(tintedMessageLastChildMobile);
                  tintedMessageLastChildMobile =
                    tintedMessageMobile.lastElementChild;
                }

                if (tintedProducts.length > 0) {
                  let ul = document.createElement("ul");

                  tintedProducts.forEach((product) => {
                    let li = document.createElement("li");
                    li.innerText = product.trim();
                    ul.append(li);
                  });

                  tintedMessage.append(ul);
                  tintedMessageMobile.append(ul.cloneNode(true));

                  disableCheckoutButton(checkoutButton);
                }

                tintedMessage.style.display = "block";
                tintedMessageMobile.style.display = "block";

                resetButton();
              } else if (responseData.returned_rates.rates.length === 0) {
                blockedMessage.style.display = "block";
                blockedMessageMobile.style.display = "block";

                resetButton();
              } else {
                resetCheckoutButton(checkoutButton);

                resultElem.innerText = "Available shipping rates:";
                resultElemMobile.innerText = "Available shipping rates:";

                appendDropShipAccordion(resultElem);
                appendDropShipAccordion(resultElemMobile);

                responseData.returned_rates.rates.forEach((rate) => {
                  displayRateCard(rate);
                });

                resetButton();

                if (!preselectedFound) {
                  handleRateClick(
                    responseData.returned_rates.rates[0].service_code,
                    responseData.returned_rates.rates[0].service_name,
                    responseData.returned_rates.rates[0].total_price,
                  );
                }
              }
            })
            .catch((error) => {
              console.error(error);

              displayRateCard(backupRate);
              resetButton();
            });
        })
        .catch((error) => {
          console.error(error);

          displayRateCard(backupRate);
          resetButton();
        });
    } else {
      customCheckoutError.innerText = "Please enter a full postcode";
      customCheckoutError.style.display = "block";

      customCheckoutErrorMobile.innerText = "Please enter a full postcode";
      customCheckoutErrorMobile.style.display = "block";

      resetButton();
    }
  }

  if (postcodeElem.value && postcodeElem.value != " " && !preClick) {
    preClick = true;

    estimateButton.click();
  }

  if (
    postcodeElemMobile.value &&
    postcodeElemMobile.value != " " &&
    !preClick
  ) {
    preClick = true;

    estimateButtonMobile.click();
  }
}

function displayRateCard(rate) {
  let card = document.createElement("div");

  card.classList.add("shipping-rate-card");
  card.setAttribute("service-code", rate.service_code);
  card.setAttribute("service-name", rate.service_name);
  card.setAttribute("total-price", rate.total_price);

  let radio = document.createElement("div");
  radio.classList.add("shipping-rate-radio");
  card.append(radio);

  let radioOutline = document.createElement("span");
  radioOutline.classList.add("shipping-rate-radio-outline");
  radio.append(radioOutline);

  let radioInner = document.createElement("span");
  radioInner.classList.add("shipping-rate-radio-inner");

  if (!preselectedFound && rate.service_code.includes("-preselected")) {
    preselectedFound = true;

    radioInner.classList.add("shipping-rate-radio-selected");

    selectedShippingServiceCodeElem.value = rate.service_code;
    selectedShippingServiceNameElem.value = rate.service_name;

    updateTotals(rate.total_price);
  }

  radioOutline.append(radioInner);

  let cardInfo = document.createElement("div");
  card.append(cardInfo);

  let title = document.createElement("p");
  title.classList.add("shipping-rate-title");
  title.innerText = rate.service_name;

  cardInfo.append(title);

  let desc = document.createElement("small");
  desc.classList.add("shipping-rate-dec");
  desc.innerText = rate.description;

  cardInfo.append(desc);

  let price = document.createElement("span");
  price.classList.add("shipping-rate-price");

  if (rate.total_price === 0) {
    price.innerText = "FREE";
  } else {
    if (rate.total_price < 100) {
      price.innerText = `£0`;
    } else {
      price.innerHTML = showSuperScriptPrices
        ? superScriptMoney(formatMoney(rate.total_price))
        : formatMoney(rate.total_price);
    }
  }

  card.append(price);

  card.addEventListener("click", (e) => {
    handleRateClick(rate.service_code, rate.service_name, rate.total_price);
  });

  resultElem.append(card);

  mobileCard = card.cloneNode(true);

  mobileCard.addEventListener("click", (e) => {
    handleRateClick(rate.service_code, rate.service_name, rate.total_price);
  });

  resultElemMobile.append(mobileCard);
}

function appendDropShipAccordion(container) {
  const {
    hasDropShip: hasDropShipEl,
    onlyDropShip: onlyDropShipEl,
    dropShipProducts: dropShipProductsEl,
  } = getDropShipElems();

  if (hasDropShipEl?.value !== "true") return;

  const dropShipProductsStr = dropShipProductsEl?.value;
  if (!dropShipProductsStr) return;

  const items = dropShipProductsStr.split(";;").map((item) => {
    const [title, estimate] = item.split("##");
    return { title, estimate };
  });

  const onlyDropShip = onlyDropShipEl?.value === "true";
  const message = window.dropShipMixedMessage || "Some items will arrive later";

  const alertSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="drop-ship-alert-icon"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`;
  const caretSvg = `<svg aria-hidden="true" focusable="false" class="icon icon-chevron drop-ship-caret" viewBox="0 0 12.96 7.14"><g><path fill="#c1c1c6" d="M0,6.47L6.47,0l6.5,6.47-.67,.67L6.47,1.34,.67,7.14l-.67-.67Z"/></g></svg>`;

  const details = document.createElement("details");
  details.classList.add("drop-ship-accordion");

  const summary = document.createElement("summary");
  summary.classList.add("drop-ship-accordion__summary");
  summary.innerHTML = `${alertSvg}<span>${message}</span>${caretSvg}`;

  const content = document.createElement("div");
  content.classList.add("drop-ship-accordion__content");

  const ul = document.createElement("ul");
  ul.classList.add("drop-ship-items-list");
  items.forEach((item) => {
    const li = document.createElement("li");
    li.textContent = `${item.title}: ${item.estimate}`;
    ul.append(li);
  });

  content.append(ul);
  details.append(summary, content);
  container.append(details);
}

function attachDiscountEvents() {
  const discountCodeShowButton = document.getElementById("discount-code-show");
  const discountCodeEntry = document.getElementById("discount-code-entry");
  const discountCodeInput = document.getElementById("cart-discount-code-input");
  const discountCodeForm = document.getElementById("cart-discount-code-form");
  const discountCodeButton = document.getElementById(
    "cart-discount-code-submit",
  );
  const discountCodeError = document.getElementById("cart-discount-error");
  const discountResult = document.getElementById("cart-discount-result");
  const discountResultTitle = document.getElementById("cart-discount-title");
  const discountResultSummary = document.getElementById(
    "cart-discount-summary",
  );
  const discountCodeElem = document.querySelector(
    '[name="attributes[discountCode]"]',
  );

  if (!discountCodeShowButton) return;

  discountCodeShowButton.addEventListener("click", function (e) {
    discountCodeEntry.style.display = "grid";
    discountCodeShowButton.style.display = "none";
  });

  discountCodeForm.addEventListener("submit", function (e) {
    e.preventDefault();
    discountCodeButton.setAttribute("disabled", "disabled");
    discountCodeButton.innerHTML = ellipsis;
    let code = discountCodeInput.value;
    fetch(
      "https://etempashopifyapps-server-a.co.uk/endpoints/discount_codes/apply_cart_code.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        mode: "cors",
        body: JSON.stringify({
          code: code,
        }),
      },
    )
      .then((response) => response.json())
      .then((responseData) => {
        console.log(responseData);
        if (responseData.failed) {
          discountCodeError.innerText = responseData.error_message;
          discountCodeError.style.display = "block";
          discountResult.style.display = "none";
          resetDiscountButton(discountCodeButton);
        } else if (responseData.no_code) {
          discountCodeError.innerText = "Invalid code. Please try again.";
          discountCodeError.style.display = "block";
          discountResult.style.display = "none";
          resetDiscountButton(discountCodeButton);
        } else {
          discountCodeError.innerText = "";
          discountCodeError.style.display = "none";
          discountResult.style.display = "block";
          discountResultTitle.innerText = code;
          discountResultSummary.innerText = responseData.code_summary;
          discountCodeElem.value = code;
          resetDiscountButton(discountCodeButton);
        }
      })
      .catch((error) => {
        console.error(error);
        discountCodeError.innerText =
          "Oops! Looks like something has gone wrong. Please refresh the page or try again later";
        discountCodeError.style.display = "block";
        discountResult.style.display = "none";
        resetDiscountButton(discountCodeButton);
      });
  });

  if (discountCodeElem.value && discountCodeElem.value != " ") {
    discountCodeShowButton.click();
    discountCodeInput.value = discountCodeElem.value;
    discountCodeButton.click();
  }
}

attachDiscountEvents();

function setupCheckout() {
  checkoutButton.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("start checkout");
      button.setAttribute("disabled", "disabled");
      button.innerHTML = ellipsis;

      cartErrors.innerText = "";
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((cart) => {
          console.log(cart);
          assignHazardous(cart.items);
          checkSelectedShipping();
          updateCart(); // submits form at end
        })
        .catch((error) => {
          console.error(error);
          cartErrors.innerText =
            "Oops! Looks like something has gone wrong. Please refresh the page or try again later";
        });
    });
  });
}

setupCheckout();
